import FontBody1 from "../../fonts/font-body1/font-body1";
import FontBody3 from "../../fonts/font-body3/font-body3";
import FontBody4 from "../../fonts/font-body4/font-body4";
import { IShop } from "../../../models/User";

interface IShopLabelProps {
    shop: Pick<IShop, 'id' | 'name' | 'display_name' | 'global_e_user_id'>;
}

const ShopLabel: React.FC<IShopLabelProps> = ({ shop }) => {
    const displayName = shop.display_name || null;
    const globalEUserId = shop.global_e_user_id || null;

    return (
        <>
            <FontBody1>{shop.name}</FontBody1>
            {displayName && <FontBody3>{` - ${displayName}`}</FontBody3>}
            {globalEUserId && <FontBody3>{` ${globalEUserId}`}</FontBody3>}
            <FontBody4>{` (${shop.id})`}</FontBody4>
        </>
    );
};

export default ShopLabel;
